import { withDependencies } from '@wix/thunderbolt-ioc'
import type { ICustomCssAPI } from '../types'
import type { IModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import { name, CustomCssAPISymbol } from '../symbols'

export const CustomCss = withDependencies(
	[CustomCssAPISymbol],
	(customCssAPI: ICustomCssAPI): IModelUpdatesHandlersImplementor => {
		return {
			featureName: name,
			handlers: {
				refreshCustomCSS: customCssAPI.refreshCustomStyles,
			},
		}
	}
)
